import React from 'react';
import '@uppy/core/dist/style.min.css';
import '@uppy/drag-drop/dist/style.min.css';
import '@uppy/status-bar/dist/style.min.css';
import clsx from 'clsx';
import TableWrapper from '@/components/table/TableWrapper';
import {
  columnCreatedOn,
  columnDescription,
  columnName,
  columnSize,
  columnTools,
  columnTransferable,
  columnType,
  columnViewing,
} from '@/constants/fields';
import { removeEmpty } from '@/utils/resultsHelper';
import DatasetAttachmentsTableHeader from './DatasetAttachmentsTableHeader';
import DatasetAttachmentsTableBody from './DatasetAttachmentsTableBody';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';
import Fetch from '../hooks/fetch';
import UppyHooks from '../hooks/uppy';

const buildColumns = ({ canUpdate }) => removeEmpty([
  columnName,
  columnDescription,
  columnType,
  columnSize,
  canUpdate ? columnViewing : null,
  canUpdate ? columnTransferable : null,
  columnCreatedOn,
  columnTools,
]);

const DatasetAttachmentsTable = ({ category, code }) => {
  const state = Selectors.useDatasetAttachmentsTable({ category, code });
  const fetchAttachments = Events.useFetchDatasetAttachments(category, { code });
  const startUpload = Events.useDatasetAttachmentsUpload(category, { code });
  const uploadsFail = Events.useDatasetAttachmentsUploadFail(category, { code });
  const uploadRemoved = Events.useDatasetAttachmentUploadRemoved(category, { code });
  const uploadSuccess = Events.useDatasetAttachmentUploadSuccess(category, { code });
  const uppy = UppyHooks.useDatasetAttachmentsUppy(
    code,
    state,
    fetchAttachments,
    startUpload,
    uploadRemoved,
    uploadsFail,
    uploadSuccess,
    state.path,
  );

  Fetch.useFetchDatasetAttachments({ category, code, exists: state.exists }, state.readStatus);
  const classes = { editable: state.items.length > 0 && state.canUpdate && !state.isEditing, wizard: state.wizardOn };
  const columns = buildColumns(state);

  return (
    <div className={clsx('aridhia-dataset-attachments-table-container', classes)}>
      <TableWrapper className="aridhia-dataset-attachments-table">
        <DatasetAttachmentsTableHeader
          category={category}
          code={code}
          columns={columns}
          items={state.items}
          uppy={uppy}
        />
        <DatasetAttachmentsTableBody category={category} code={code} columns={columns} items={state.items} />
      </TableWrapper>
    </div>
  );
};

export default DatasetAttachmentsTable;
